<template>
  <div class="helpTab">
    <div class="cont">
      <div class="close" @click="close">
        <img src="@/../public/static/img/blockView/close.png">
      </div>
      <h3 class="h3" v-text="$t('Help')"></h3>
      <div class="box">
        <div class="icon">
          <span class="hexagon">B</span>
        </div>
        <span class="key" v-text="$t('Blocks')"></span>
      </div>
      <div class="box">
        <div class="icon">
          <span class="hexagon">C</span>
        </div>
        <span class="key" v-text="$t('Concensus')"></span>
      </div>
      <div class="box">
        <div class="icon">
          <span class="hexagon">D</span>
        </div>
        <span class="key" v-text="$t('Difficulty')"></span>
      </div>
      <div class="box">
        <div class="icon">
          <span class="hexagon">H</span>
        </div>
        <span class="key" v-text="$t('Height')"></span>
      </div>
      <div class="box HyperBlock">
        <div class="icon">
          <img src="@/../public/static/img/blockView/hyperBlock.png">
        </div>
        <span class="key" v-text="$t('HyperBlock')"></span>
      </div>
      <div class="box Localchain">
        <div class="icon">
          <img src="@/../public/static/img/blockView/Localchain.png">
        </div>
        <span class="key" v-text="$t('LocalBlockId')"></span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods:{
    close(){
      this.$emit('close');
    }
  }
}
</script>


